<button mat-menu-item (click)="onLogoutEvent()" adf-logout>
  <mat-icon>
    <span class="wk-icon-logout"></span>
  </mat-icon>
  <span>{{ 'APP.SIGN_OUT.TITLE' | translate }}</span>
</button>
